export function disableFormSubmissionIfInvalid(form, submitButton) {
  const formInputs = Array.from(form.querySelectorAll('input:not(input[type=hidden])')).concat(
    Array.from(form.querySelectorAll('textarea'))
  )

  formInputs.forEach(input => {
    input.addEventListener('input', () => {
      const invalidInputs = Array.from(form.querySelectorAll('input:invalid')).concat(
        Array.from(form.querySelectorAll('textarea:invalid'))
      )

      submitButton.disabled = invalidInputs.length > 0
    })
  })
}
